import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { datacenterOptionLabel } from '../domain/clientCompany.rules';
import type { DatacenterKind } from '../domain/clientCompany.types';
import type { DatacenterOption } from '../domain/options.types';

export interface AddDatacenterAssociationDialogProps {
  open: boolean;
  kind: DatacenterKind;
  datacenterId: string;
  clientDatacenterId: string;
  notes: string;
  kyndrylOptions: DatacenterOption[];
  clientOptions: DatacenterOption[];
  onKindChange: (kind: DatacenterKind) => void;
  onDatacenterIdChange: (value: string) => void;
  onClientDatacenterIdChange: (value: string) => void;
  onNotesChange: (value: string) => void;
  onClose: () => void;
  onSave: () => void;
  saving: boolean;
}

// UC-11 (decisión E: literales españoles as-is). Sub-diálogo de asociar datacenter, puro por
// props — el diálogo padre (`CompanyDatacentersDialog`) posee `useCompanyDatacenters`.
export default function AddDatacenterAssociationDialog({
  open,
  kind,
  datacenterId,
  clientDatacenterId,
  notes,
  kyndrylOptions,
  clientOptions,
  onKindChange,
  onDatacenterIdChange,
  onClientDatacenterIdChange,
  onNotesChange,
  onClose,
  onSave,
  saving,
}: AddDatacenterAssociationDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Asociar datacenter</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid size={12}>
            <FormControl fullWidth>
              <InputLabel>Tipo de datacenter</InputLabel>
              <Select
                value={kind}
                label="Tipo de datacenter"
                onChange={(e) => onKindChange(e.target.value as DatacenterKind)}
              >
                <MenuItem value="kyndryl">Kyndryl (compartido)</MenuItem>
                <MenuItem value="client">Propio del cliente</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid size={12}>
            {kind === 'kyndryl' ? (
              <FormControl fullWidth>
                <InputLabel>Datacenter Kyndryl</InputLabel>
                <Select
                  value={datacenterId}
                  label="Datacenter Kyndryl"
                  onChange={(e) => onDatacenterIdChange(e.target.value)}
                >
                  {kyndrylOptions.map((dc) => (
                    <MenuItem key={dc.id} value={dc.id}>
                      {datacenterOptionLabel(dc)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : (
              <FormControl fullWidth>
                <InputLabel>Datacenter propio del cliente</InputLabel>
                <Select
                  value={clientDatacenterId}
                  label="Datacenter propio del cliente"
                  onChange={(e) => onClientDatacenterIdChange(e.target.value)}
                >
                  {clientOptions.length === 0 && (
                    <MenuItem disabled>
                      No hay DCs propios registrados. Créalos primero en la pestaña Datacenters.
                    </MenuItem>
                  )}
                  {clientOptions.map((dc) => (
                    <MenuItem key={dc.id} value={dc.id}>
                      {datacenterOptionLabel(dc)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </Grid>
          <Grid size={12}>
            <TextField
              fullWidth
              label="Notas"
              multiline
              rows={2}
              value={notes}
              onChange={(e) => onNotesChange(e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={onSave} disabled={saving}>
          {saving ? 'Guardando...' : 'Asociar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
